import { FC, useEffect, useState } from 'react';
import Select, { ActionMeta, SingleValue } from 'react-select';
import { styled } from 'styled-components';

interface Option {
	label: string;
	value: string;
}
interface IAutoComplete {
	options: Option[];
	value: any;
	placeholder?: string;
	onChange: (option: SingleValue<Option>, actionMeta?: ActionMeta<Option>) => void;
	onFocus?: () => void;
	onBlur?: () => void;
}
const AutoComplete: FC<IAutoComplete> = ({ options = [], value, placeholder = '', onChange, onFocus, onBlur }) => {
	const [selectedOption, setSelectedOption] = useState<Option | undefined>();

	useEffect(() => {
		setSelectedOption(options.find((option: Option) => option.value === value));
	}, [options, value]);

	return (
		<Container>
			<Select
				id="search-box"
				inputId="search-box-input"
				className="search-box"
				classNamePrefix="select"
				placeholder={placeholder}
				options={options}
				isMulti={false}
				isClearable={true}
				onChange={onChange}
				onFocus={onFocus}
				onBlur={onBlur}
				controlShouldRenderValue={true}
				openMenuOnClick={false}
				value={selectedOption}
			/>
		</Container>
	);
};

export default AutoComplete;

const Container = styled.div`
	span {
		font-size: 28px;
		margin-right: 30px;
		font-weight: 300;
	}

	.search-box {
		font-family: 'Untitled Sans', sans-serif;
		font-size: 14px;
		letter-spacing: 1px;
		font-weight: 300;

		.select__control {
			transition: all 100ms;
			border-radius: 0.33rem;
			box-shadow: inset 2px 2px 2px #0000001a;
			align-content: center;
			border: solid 1px #dbdbdb;
			min-height: 30px;

			.select__value-container {
				line-height: 1;
			}

			&.select__control--is-focused {
				border-color: #dbdbdb;
				box-shadow: none;

				.select__placeholder {
					display: block;
				}
			}

			.select__indicators {
				.select__indicator-separator {
					display: none;
				}

				.select__dropdown-indicator {
					display: none;
				}
			}

			input {
				width: auto !important;
			}
		}

		.select__menu {
			z-index: 999;

			.select__menu-list {
				.select__option {
					&.select__option--is-focused,
					&:hover {
						background-color: #f4f4f4;
					}
				}
			}
		}

		@media screen and (max-width: 576px) {
			.select__control {
				width: 42px;
			}
		}
	}
`;
